// extracted by mini-css-extract-plugin
export default {"header":"Header_header__KlmXR","fadeInAnimation":"Header_fadeInAnimation__UoPum","title":"Header_title__EOaF-","buttonHolder":"Header_buttonHolder__PzB8M"};